import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, OBJECT } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'feedevent'

  static get fields () {
    return {
      id: new UUID(),
      data: new OBJECT(),
      event_type: new STRING(),
      resource: new OBJECT(),
      resource_uuid: new UUID(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
